import React from "react";
import { Navigate } from "react-router-dom";
import DashboardLayout from "./components/DashboardLayout";
import MainLayout from "./components/MainLayout";
import NotFound from "./pages/Error/NotFound";
import NOTFOUNd403 from "./pages/Error/403";

// Import components directly (no lazy loading to avoid the suspend error)
import Profile from "./pages/Profile/Account";
import Dashboard from "./pages/Dashboard/Dashboard";
import LabEstimation from "./pages/LabEstimation/LabEstimation";
import CustomInstanceDetail from "./pages/LabManager/CustomDetail";
import InstanceDetail from "./pages/LabManager/Detail";
import PreconfigDetail from "./pages/LabManager/HypervisedPreconfigDetail";
import WiseLabDetail from "./pages/LabManager/WiseLabDetail";
import VirtualizationCustomInstanceDetail from "./pages/LabManager/VirtualizationCustomDetail";
import SharedvmDetail from "./pages/LabManager/SharedvmDetail";
import ManualDetails from "./pages/LabManager/ManualDetails";
import SaasDetails from "./pages/LabManager/SaasDetails";
import LabList from "./pages/LabManager/PCLabs";
import CustomLabList from "./pages/LabManager/CustomLabs";
import WiseLabList from "./pages/LabManager/WiseLabs";
import HypervisedCustomLabList from "./pages/LabManager/HVMLabs";
import SharedvmLabList from "./pages/LabManager/SVMLabs";
import ManualLabList from "./pages/LabManager/ManualLabs";
import SasLabList from "./pages/LabManager/SasLabs";
import CloudLabList from "./pages/LabManager/CloudLabs";
import RequestLayout from "./pages/DeploymentForm/Technology/RequestLayout";
import CustomLabDeployment from "./pages/DeploymentForm/CustomApplications/RequestLayout";
import HVMLabDeployment from "./pages/DeploymentForm/VirtualizationCustomLabs/RequestLayout";
import WiseLabDeployment from "./pages/DeploymentForm/WiseLabs/RequestLayout";
import Sharedvm from "./pages/DeploymentForm/SharedVM/RequestLayout";
import Clouddeploy from "./pages/DeploymentForm/CloudLabs/RequestLayout";
import Schedule from "./pages/ScheduleForm/Schedule/Schedule";
import CustomSchedule from "./pages/ScheduleForm/CustomSchedule/Schedule";
import WiseSchedule from "./pages/ScheduleForm/WiseSchedule/Schedule";
import HVMSchedule from "./pages/ScheduleForm/HVMSchedule/Schedule";
import SVMSchedule from "./pages/ScheduleForm/SVMSchedule/Schedule";
import CloudSchedule from "./pages/ScheduleForm/CloudSchedule/Schedule";
import PreconfigBilling from "./pages/BillingForm/PreconfigLabsBilling/Billinginfo";
import CloudBilling from "./pages/BillingForm/CloudLabsBilling/Billinginfo";
import CustomBilling from "./pages/BillingForm/CustomLabsBilling/Billinginfo";
import HypervisedBilling from "./pages/BillingForm/VirtualizationCustomLabsBilling/Billinginfo";
import Overview from "./pages/BillingForm/Overview";
import SharedBilling from "./pages/BillingForm/SharedVMBilling/Billinginfo";
import WiseBilling from "./pages/BillingForm/WiseLabsBilling/Billinginfo";
import MCQ from "./pages/QuizManagement/MainQuiz.js";
import MCQTable from "./pages/QuizManagement/Table.js";
import QuizAssign from "./pages/QuizManagement/QuizAssign";
import QuizEdit from "./pages/QuizManagement/QuizEdit";
import QuizManage from "./pages/QuizManagement/QuizManage";
import QuizScore from "./pages/QuizManagement/QuizScore";
import QuizView from "./pages/QuizManagement/QuizView";

// Import remaining components directly
import AddTrainees from "./pages/AddTrainees/trainee";
import AssignTrainer from "./pages/AssignTrainer/Management";
import AdminFeedback from "./pages/Feedback/Feedback";
import ConnectivityCheck from "./pages/Connectivitytest/ConnectivityTest";
import Usermodify from "./pages/Management/Usermodify";
import Groupmodify from "./pages/Management/Groupmodify";
import CloudLabDetail from "./components/labstructure/Cloudlabs/Detail";
import NewEditForm from "./pages/LabManager/NewEditForm";
import AboutPage from "./pages/About/AboutPage";
import CustomizationRequst from "./pages/CustomizationRequest/create";
import CustomizationRequestList from "./pages/CustomizationRequest/statuslist";
import Organization from "./pages/Management/Organization";
import Users from "./pages/Management/Users";
import Groups from "./pages/Management/Groups";
import Judge0 from "./pages/Judge0/Judge0";
import GuacamolePage from "./pages/LabManager/GuacamolePage";
import BulkUser from "./pages/BulkUser/BulkUserTable";

import TrainerLayout from "./components/TrainerLayout";
import TrainerFeedback from "./pages/Trainer/Feedback/TrainerFeedback";
import TrainerDashboard from "./pages/Trainer/Dashboard/Dashboard";
import TrainerLabs from "./pages/Trainer/RunningLabs/Main";
import TrainerPCCDetail from "./pages/Trainer/RunningLabs/Detail";
import TrainerCustomDetail from "./pages/Trainer/RunningLabs/CustomDetail";
import TrainerHypervmDetail from "./pages/Trainer/RunningLabs/HvmDetail";
import TrainerSharedvmDetail from "./pages/Trainer/RunningLabs/SvmDetail";
import TrainerCloudDetail from "./pages/Trainer/RunningLabs/CloudDetail";
import TrainerWiseDetail from "./pages/Trainer/RunningLabs/WiseLabDetail";
import TrainerManualDetail from "./pages/Trainer/RunningLabs/ManualDetails";
import TrainerSaasDetail from "./pages/Trainer/RunningLabs/SaasDetails";
import TrainerGuacamolePage from "./pages/Trainer/RunningLabs/TrainerGuacamolePage";

import TraineeLayout from "./components/TraineeLayout";
import TraineeLabs from "./pages/Trainee/RunningLabs/Main";
import Feedback from "./pages/Trainee/Feedback/FeedbackListPage";
import AssessmentList from "./pages/Trainee/Assessment/AssessmentList";
import SubmitQuestionCard from "./pages/Trainee/Assessment/QuestionsCard";
import Submitfeedback from "./pages/Trainee/Feedback/Feedback";
import TraineePCCDetail from "./pages/Trainee/RunningLabs/Detail";
import TraineeCustomDetail from "./pages/Trainee/RunningLabs/CustomDetail";
import TraineeHypervmDetail from "./pages/Trainee/RunningLabs/HvmDetail";
import TraineeSharedvmDetail from "./pages/Trainee/RunningLabs/SvmDetail";
import TraineeCloudDetail from "./pages/Trainee/RunningLabs/CloudDetail";
import TraineeWiseDetail from "./pages/Trainee/RunningLabs/WiseLabDetail";
import TraineeManualDetails from "./pages/Trainee/RunningLabs/ManualDetails";
import TraineeSaasDetails from "./pages/Trainee/RunningLabs/SaasDetails";
import TraineeGuacamolePage from "./pages/Trainee/RunningLabs/TraineeGuacamolePage";

import Succeeded from "./pages/BillingForm/Success/Success";
import TrainerMCQ from "./pages/QuizManagement/MainQuiz.js";
import TrainerMCQTable from "./pages/QuizManagement/Table.js";
import TrainerQuizAssign from "./pages/QuizManagement/QuizAssign";
import TrainerQuizEdit from "./pages/QuizManagement/QuizEdit";
import TrainerQuizManage from "./pages/QuizManagement/QuizManage";
import TrainerQuizScore from "./pages/QuizManagement/QuizScore";
import TrainerQuizView from "./pages/QuizManagement/QuizView";

if (localStorage.getItem("group") === "admin") {
  var routes = [
    {
      path: "app",
      element: <DashboardLayout />,
      children: [
        { path: "profile", element: <Profile /> },
        { path: "connectivitycheck", element: <ConnectivityCheck /> },
        { path: "dashboard", element: <Dashboard /> },
        { path: "maindeployment/labrequest", element: <RequestLayout /> },
        { path: "maindeployment/instancerequest", element: <CustomLabDeployment /> },
        { path: "maindeployment/hvminstance", element: <HVMLabDeployment /> },
        { path: "maindeployment/sharedvminstance", element: <Sharedvm /> },
        { path: "maindeployment/wiserequest", element: <WiseLabDeployment /> },
        { path: "maindeployment/cloudrequest", element: <Clouddeploy /> },
        // { path: "maindeployment/manualrequest", element: <ManualDeploy /> },
        { path: "personalizedrequest", element: <CustomizationRequst /> },
        // { path: "maindeployment/labrequest1", element: <RequestLayout1 /> },
        { path: "instance/preconfig", element: <LabList /> },
        { path: "instance/custom", element: <CustomLabList /> },
        { path: "instance/wiselabs", element: <WiseLabList /> },
        {
          path: "instance/hypervisedcustom",
          element: <HypervisedCustomLabList />,
        },
        { path: "instance/manual", element: <ManualLabList /> },
        { path: "instance/saas", element: <SasLabList /> },
        { path: "instance/sharedvm", element: <SharedvmLabList /> },
        { path: "instance/cloudlabs", element: <CloudLabList /> },
        { path: "personalizedlist", element: <CustomizationRequestList /> },
        { path: "instanceedit", element: <InstanceDetail /> },
        { path: "preconfiginstanceedit", element: <PreconfigDetail /> },
        { path: "custom/instanceedit", element: <CustomInstanceDetail /> },
        { path: "wiselab/instanceedit", element: <WiseLabDetail /> },
        {
          path: "virtualizationinstanceedit",
          element: <VirtualizationCustomInstanceDetail />,
        },
        { path: "cloudlab/moreinfo", element: <CloudLabDetail /> },
        { path: "sharedvmedit", element: <SharedvmDetail /> },
        { path: "manualedit", element: <ManualDetails /> },
        { path: "sasedit", element: <SaasDetails /> },
        { path: "neweditform", element: <NewEditForm /> },
        // { path: "management", element: <Management /> },
        { path: "schedule", element: <Schedule /> },
        { path: "customschedule", element: <CustomSchedule /> },
        { path: "cloudschedule", element: <CloudSchedule /> },
        { path: "wiseschedule", element: <WiseSchedule /> },
        { path: "hvmschedule", element: <HVMSchedule /> },
        { path: "svmschedule", element: <SVMSchedule /> },
        { path: "usermodify", element: <Usermodify /> },
        { path: "groupmodify", element: <Groupmodify /> },
        { path: "preconfig/billinginfo", element: <PreconfigBilling /> },
        { path: "cloudlab/billinginfo", element: <CloudBilling /> },
        { path: "custom/billinginfo", element: <CustomBilling /> },
        { path: "hypervised/billinginfo", element: <HypervisedBilling /> },
        { path: "shared/billinginfo", element: <SharedBilling /> },
        { path: "wise/billinginfo", element: <WiseBilling /> },
        { path: "overview", element: <Overview /> },
        { path: "estimation", element: <LabEstimation /> },
        { path: "addtrainees", element: <AddTrainees /> },
        { path: "assigntrainer", element: <AssignTrainer /> },
        { path: "bulkuser", element: <BulkUser /> },
        { path: "adminfeedback", element: <AdminFeedback /> },
        { path: "quiztable/", element: <MCQTable /> },
        { path: "view/", element: <QuizView /> },
        { path: "edit/", element: <QuizEdit /> },
        { path: "assign/", element: <QuizAssign /> },
        { path: "manage/", element: <QuizManage /> },
        { path: "score/", element: <QuizScore /> },
        { path: "quiz/", element: <MCQ /> },
        { path: "judge", element: <Judge0 /> },
        { path: "organization", element: <Organization /> },
        { path: "guacamole", element: <GuacamolePage /> },
        { path: "users", element: <Users /> },
        { path: "groups", element: <Groups /> },
        { path: "403", element: <NOTFOUNd403 /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    {
      path: "app",
      children: [
        { path: "about", element: <AboutPage /> },
        { path: "guacconnect", element: <GuacamolePage /> },

      ],
    },
    {
      path: "/",
      element: <MainLayout />,
      children: [
        { path: "404", element: <NotFound /> },
        { path: "success:identity", element: <Succeeded /> },
        { path: "/", element: <Navigate to="/app/dashboard" /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
  ];
} else if (localStorage.getItem("group") === "trainer") {
  var routes = [
    {
      path: "app",
      element: <TrainerLayout />,
      children: [
        { path: "profile", element: <Profile /> },
        { path: "connectivitycheck", element: <ConnectivityCheck /> },
        { path: "dashboard", element: <TrainerDashboard /> },
        { path: "trainerfeedback", element: <TrainerFeedback /> },
        { path: "trainerquiztable/", element: <TrainerMCQTable /> },
        { path: "traineview/", element: <TrainerQuizView /> },
        { path: "traineredit/", element: <TrainerQuizEdit /> },
        { path: "trainerassign/", element: <TrainerQuizAssign /> },
        { path: "trainermanage/", element: <TrainerQuizManage /> },
        { path: "trainerscore/", element: <TrainerQuizScore /> },
        { path: "trainerquiz/", element: <TrainerMCQ /> },
        { path: "runninglabs", element: <TrainerLabs /> },
        { path: "preconfig/detail", element: <TrainerPCCDetail /> },
        { path: "custom/detail", element: <TrainerCustomDetail /> },
        { path: "hypervised/detail", element: <TrainerHypervmDetail /> },
        { path: "shared/detail", element: <TrainerSharedvmDetail /> },
        { path: "cloud/detail", element: <TrainerCloudDetail /> },
        { path: "wise/detail", element: <TrainerWiseDetail /> },
        { path: "manual/detail", element: <TrainerManualDetail /> },
        { path: "saas/detail", element: <TrainerSaasDetail /> },
        { path: "judge", element: <Judge0 /> },
        { path: "403", element: <NOTFOUNd403 /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    {
      path: "app",
      children: [{ path: "about", element: <AboutPage /> },
      { path: "trainerguacconnect", element: <TrainerGuacamolePage /> },
      ],

    },
    {
      path: "/",
      element: <MainLayout />,
      children: [
        { path: "404", element: <NotFound /> },
        { path: "/", element: <Navigate to="/app/dashboard" /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
  ];
} else if (localStorage.getItem("group") === "trainee") {
  var routes = [
    {
      path: "app",
      element: <TraineeLayout />,
      children: [
        { path: "profile", element: <Profile /> },
        { path: "connectivitycheck", element: <ConnectivityCheck /> },
        // { path: 'dashboard', element: <TraineeDashboard /> },
        { path: "runninglabs", element: <TraineeLabs /> },
        { path: "feedback", element: <Feedback /> },
        // { path: "assessment", element: <QuestionCard /> },
        { path: "assessmentlist", element: <AssessmentList /> },
        // { path: "assessmentquestionlist", element: <AssessmentQuestionList /> },
        { path: "assessmentquestion", element: <SubmitQuestionCard /> },
        { path: "submitfeedback", element: <Submitfeedback /> },
        { path: "preconfig/detail", element: <TraineePCCDetail /> },
        { path: "custom/detail", element: <TraineeCustomDetail /> },
        { path: "hypervised/detail", element: <TraineeHypervmDetail /> },
        { path: "shared/detail", element: <TraineeSharedvmDetail /> },
        { path: "cloud/detail", element: <TraineeCloudDetail /> },
        { path: "wise/detail", element: <TraineeWiseDetail /> },
        { path: "manual/detail", element: <TraineeManualDetails /> },
        { path: "saas/detail", element: <TraineeSaasDetails /> },
        { path: "judge", element: <Judge0 /> },
        { path: "403", element: <NOTFOUNd403 /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    {
      path: "app",
      children: [
        { path: "traineeguacconnect", element: <TraineeGuacamolePage /> },
      ],

    },
    {
      path: "/",
      element: <MainLayout />,
      children: [
        { path: "404", element: <NotFound /> },
        { path: "/", element: <Navigate to="/app/runninglabs" /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
  ];
} else if (localStorage.getItem("group") === "ops_users") {
  var routes = [
    {
      path: "app",
      element: <DashboardLayout />,
      children: [
        { path: "profile", element: <Profile /> },
        { path: "connectivitycheck", element: <ConnectivityCheck /> },
        { path: "dashboard", element: <Dashboard /> },
        { path: "maindeployment/instancerequest", element: <CustomLabDeployment /> },
        { path: "maindeployment/cloudrequest", element: <Clouddeploy /> },
        { path: "maindeployment/labrequest", element: <RequestLayout /> },
        { path: "maindeployment/hvminstance", element: <HVMLabDeployment /> },
        { path: "maindeployment/sharedvminstance", element: <Sharedvm /> },
        { path: "personalizedrequest", element: <CustomizationRequst /> },
        { path: "instance/preconfig", element: <LabList /> },
        { path: "instance/custom", element: <CustomLabList /> },
        {
          path: "instance/hypervisedcustom", element: <HypervisedCustomLabList />,
        },
        { path: "instance/sharedvm", element: <SharedvmLabList /> },
        { path: "instance/cloudlabs", element: <CloudLabList /> },
        { path: "instance/manual", element: <ManualLabList /> },
        { path: "instance/saas", element: <SasLabList /> },
        { path: "personalizedlist", element: <CustomizationRequestList /> },
        { path: "instanceedit", element: <InstanceDetail /> },
        { path: "custom/instanceedit", element: <CustomInstanceDetail /> },
        { path: "cloudlab/moreinfo", element: <CloudLabDetail /> },
        {
          path: "virtualizationinstanceedit",
          element: <VirtualizationCustomInstanceDetail />,
        },
        { path: "sharedvmedit", element: <SharedvmDetail /> },
        { path: "schedule", element: <Schedule /> },
        { path: "customschedule", element: <CustomSchedule /> },
        { path: "hvmschedule", element: <HVMSchedule /> },
        { path: "svmschedule", element: <SVMSchedule /> },
        { path: "cloudschedule", element: <CloudSchedule /> },
        { path: "preconfig/billinginfo", element: <PreconfigBilling /> },
        { path: "cloudlab/billinginfo", element: <CloudBilling /> },
        { path: "custom/billinginfo", element: <CustomBilling /> },
        { path: "hypervised/billinginfo", element: <HypervisedBilling /> },
        { path: "shared/billinginfo", element: <SharedBilling /> },
        { path: "wise/billinginfo", element: <WiseBilling /> },
        { path: "overview", element: <Overview /> },
        { path: "estimation", element: <LabEstimation /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    {
      path: "app",
      children: [{ path: "about", element: <AboutPage /> }],
    },
    {
      path: "/",
      element: <MainLayout />,
      children: [
        { path: "404", element: <NotFound /> },
        { path: "/", element: <Navigate to="/app/dashboard" /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
  ];
} else {
  var routes = [
    {
      path: "app",
      element: <DashboardLayout />,
      children: [
        { path: "profile", element: <Profile /> },
        { path: "connectivitycheck", element: <ConnectivityCheck /> },
        { path: "dashboard", element: <Dashboard /> },
        { path: "instance/preconfig", element: <LabList /> },
        { path: "instance/custom", element: <CustomLabList /> },
        {
          path: "instance/hypervisedcustom",
          element: <HypervisedCustomLabList />,
        },
        { path: "instance/sharedvm", element: <SharedvmLabList /> },
        { path: "instance/cloudlabs", element: <CloudLabList /> },
        { path: "instance/manual", element: <ManualLabList /> },
        { path: "instance/saas", element: <SasLabList /> },
        { path: "instanceedit", element: <InstanceDetail /> },
        { path: "custom/instanceedit", element: <CustomInstanceDetail /> },
        { path: "cloudlab/moreinfo", element: <CloudLabDetail /> },
        {
          path: "virtualizationinstanceedit",
          element: <VirtualizationCustomInstanceDetail />,
        },
        { path: "sharedvmedit", element: <SharedvmDetail /> },
        { path: "schedule", element: <Schedule /> },
        { path: "customschedule", element: <CustomSchedule /> },
        { path: "hvmschedule", element: <HVMSchedule /> },
        { path: "svmschedule", element: <SVMSchedule /> },
        { path: "cloudschedule", element: <CloudSchedule /> },
        { path: "estimation", element: <LabEstimation /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    {
      path: "app",
      children: [{ path: "about", element: <AboutPage /> }],
    },
    {
      path: "/",
      element: <MainLayout />,
      children: [
        { path: "404", element: <NotFound /> },
        { path: "/", element: <Navigate to="/app/dashboard" /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
  ];
}

export default routes;
